import React from 'react'
import { Helmet } from 'react-helmet-async'
import CoursesContent from '../components/courses/CoursesContent'

export default function Courses() {
  return (
    <>
      <Helmet>
        <title>Driving Courses - A Plus A Driving School</title>
        <meta name="description" content="Explore our comprehensive driving courses including teen driver education, adult lessons, online courses, defensive driving, and more." />
      </Helmet>
      <CoursesContent />
    </>
  )
}

